module.exports = __webpack_public_path__ + "img/nav-design-modern@2x.8c97aa5.webp";